// eslint-disable-next-line
import React, { Component } from 'react';
export default class ExtendedComponent extends Component {

  set = (fieldName, value, passthrough) => {
    return new Promise((resolve, reject) => {
      this.setState({
        [fieldName]: value
      }, resolve());
    }).then(_ => passthrough || this.state);
  }

  setAll = (object, passthrough) => {
    return new Promise((resolve, reject) => {
      this.setState({
        ...object
      }, resolve());
    }).then(_ => passthrough || this.state);
  }

  log = (name) => {
    return (value) => {
      console.log(name, value);
      return value;
    };
  }
}


// WEBPACK FOOTER //
// ./src/components/views/ExtendedComponent.jsx